@let isBlocked = editDataService.documentIsBlocked();

<ra-modal
    [title]="('document.edit.contract.modalTitle' | translate)"
    [disabled]="loading()"
    (close)="close.emit()">

    <p class="ra-label-s content-secondary">{{ 'document.edit.contract.modalSubtitle' | translate }}</p>

    @if (!isBlocked) 
    {
        <div class="container-new-signer">
            
            @if (showNewSigner()) 
            {
                <div class="container-inputs-signer">
        
                    <div class="ra-grid template-col-2 gap-16" [formGroup]="formGroup">
        
                        <ra-input 
                            formControlName="name" 
                            [label]="'common.name' | translate" 
                            [placeholder]="('document.edit.contract.signerNamePlaceholder' | translate)" 
                            [leftIcon]="'profile'"
                        />
        
                        <ra-input 
                            formControlName="email" 
                            [label]="('document.edit.contract.signerEmail' | translate)" 
                            [placeholder]="('document.edit.contract.signerEmailPlaceholder' | translate)" 
                            [leftIcon]="'email'"
                        />
                    </div>
        
                    <div class="container-action-add ra-flex end gap-16">
                        <ra-button [label]="'common.cancel' | translate" [type]="'primary-outline'" (click)="showNewSigner.set(false)" />
                        
                        @if (!signerToEdit) 
                        {
                            <ra-button 
                                [label]="('document.edit.contract.addSigner' | translate)" 
                                [type]="'primary'" 
                                [loading]="loadingUpdate()"
                                (click)="saveSigner()" 
                            />
                        }
                        @else
                        {
                            <ra-button 
                                [label]="'common.save' | translate" 
                                [type]="'primary'" 
                                [loading]="loadingUpdate()"
                                (click)="saveSigner()" 
                            />
                        }
                    </div>
                </div>
            }
            @else
            {
                <div class="container-button-add ra-flex-center-between" (click)="showNewSigner.set(true)">
                    <p class="ra-label-s ra-primary">{{ 'document.edit.contract.addEmail' | translate }}</p>
                    <ra-icon class="ra-primary" icon="add" varColor="currentColor" [size]="16" />
                </div>
            }
        </div>
    }
  
    <div class="container-list">
        @for (item of editDataService.document()?.signedBy; track $index) 
        {
            <div class="container-item ra-flex-center-between">

                <div class="container-data">
                    <p class="ra-label-s">{{ item.name }}</p>
                    <p class="ra-label-xs content-tertiary">{{ item.email }}</p>
                </div>

                <div class="ra-flex-center-between gap-12">
                    @let type = getBadgeType(item.status);
                    <ra-badge 
                        [label]="item.status | signatureStatus | titlecase" 
                        [variant]="type"
                    />

                    @if (!isBlocked) 
                    {
                        <div 
                            cdkOverlayOrigin 
                            #signerOrigin="cdkOverlayOrigin">
                            <ra-square-icon
                                [icon]="'more-vertical'"
                                [tooltip]="('document.edit.contract.optionsTooltip' | translate)"
                                [size]="30"
                                (click)="toggleOptions($index)"
                            />
                        </div>

                        <ng-template
                            cdkConnectedOverlay
                            [cdkConnectedOverlayOrigin]="signerOrigin"
                            [cdkConnectedOverlayOpen]="openMenuIndex() === $index"
                            [cdkConnectedOverlayPositions]="signerOptionsPositions"
                            [cdkConnectedOverlayScrollStrategy]="scrollStrategy"
                            [cdkConnectedOverlayMinWidth]="200"
                            (overlayOutsideClick)="closeOptions()">
                            <signer-options 
                                [isHidden]="false"
                                (close)="closeOptions()"
                                (edit)="editSigner($index)"
                                (remove)="dialogConfirmRemove($index)"
                            />
                        </ng-template>
                    }
                </div>
            </div>
        }
    </div>

    @if (!isBlocked) 
    {
        <div class="container-actions">
            <ra-button 
                [label]="('document.edit.contract.sendToSignature' | translate)" 
                [loading]="loadingPublish()" 
                [disabled]="loadingPublish()"
                (click)="showConfirmation.set(true)" 
            />
        </div>
    }
</ra-modal>

@if (showSetUserSignature()) 
{
    <user-signature 
        (close)="showSetUserSignature.set(false)"
        (continue)="showSetUserSignature.set(false); close.emit()"
    />
}

@if (showConfirmation()) {
    <div class="confirm-signature-overlay" (click)="showConfirmation.set(false)">
        <div class="confirm-signature-container" (click)="$event.stopPropagation()">
            <div class="confirm-signature-header">
                <button
                    type="button"
                    class="confirm-signature-close"
                    [disabled]="loadingPublish()"
                    (click)="showConfirmation.set(false)">
                    <ra-icon icon="close" varColor="currentColor" [size]="16" />
                </button>
            </div>

            <div class="confirm-signature-content">
                <ra-icon class="confirm-signature-icon" icon="pen-draw" varColor="currentColor" [size]="32" />

                <h2 class="ra-header-s confirm-signature-title">{{ 'document.edit.contract.attentionTitle' | translate }}</h2>

                <p class="ra-label-s content-secondary confirm-signature-message">
                    {{ 'document.edit.contract.confirmSendLine1' | translate }}
                </p>
                
                <p class="ra-label-s content-secondary confirm-signature-message">
                    {{ 'document.edit.contract.confirmSendLine2' | translate }}
                </p>
            </div>

            <div class="confirm-signature-actions">
                <ra-button
                    [label]="('document.edit.contract.confirmSendButton' | translate)"
                    [type]="'primary'"
                    [loading]="loadingPublish()"
                    [disabled]="loadingPublish()"
                    (click)="sendToSignature()"
                />
            </div>
        </div>
    </div>
}
